import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/jsx-props-no-spreading */


import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
var classDirectory = {
  mini: 'xs',
  small: 'sm',
  normal: '',
  large: 'lg'
};

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input() {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.apply(this, arguments);

    _this.renderInput = function () {
      var _classNames;

      var _a = _this.props,
          size = _a.size,
          styleType = _a.styleType,
          status = _a.status,
          readOnly = _a.readOnly,
          disabled = _a.disabled,
          preAppend = _a.preAppend,
          afterAppend = _a.afterAppend,
          prefix = _a.prefix,
          suffix = _a.suffix,
          type = _a.type,
          placeholder = _a.placeholder,
          className = _a.className,
          style = _a.style,
          wrapClassName = _a.wrapClassName,
          inputRef = _a.inputRef,
          children = _a.children,
          restProps = __rest(_a, ["size", "styleType", "status", "readOnly", "disabled", "preAppend", "afterAppend", "prefix", "suffix", "type", "placeholder", "className", "style", "wrapClassName", "inputRef", "children"]);

      var inputCls = classNames('roo-input', (_classNames = {}, _defineProperty(_classNames, "roo-input-".concat(classDirectory[size || 'normal']), size), _defineProperty(_classNames, "roo-input-".concat(styleType), styleType), _classNames), className);
      var forkedProps = {
        readOnly: readOnly,
        disabled: disabled
      };
      return /*#__PURE__*/React.createElement("input", _Object$assign({}, forkedProps, restProps, {
        type: type,
        ref: inputRef,
        className: inputCls,
        style: style,
        placeholder: placeholder
      }));
    };

    _this.renderStatus = function () {
      var _this$props = _this.props,
          status = _this$props.status,
          message = _this$props.message,
          wrapClassName = _this$props.wrapClassName,
          wrapStyle = _this$props.wrapStyle;
      var wrapCls = classNames({
        'has-error': status === 'error',
        'has-success-hook': status === 'success'
      }, wrapClassName);
      return status ? /*#__PURE__*/React.createElement("div", {
        className: wrapCls,
        style: wrapStyle
      }, _this.renderInput(), /*#__PURE__*/React.createElement("p", {
        className: "help-block"
      }, message)) : _this.renderInput();
    };

    _this.renderGroup = function () {
      var _classNames2;

      var _this$props2 = _this.props,
          preAppend = _this$props2.preAppend,
          afterAppend = _this$props2.afterAppend,
          size = _this$props2.size,
          prefix = _this$props2.prefix,
          suffix = _this$props2.suffix,
          wrapClassName = _this$props2.wrapClassName,
          wrapStyle = _this$props2.wrapStyle;
      var groupCls = classNames('roo-input-group', (_classNames2 = {}, _defineProperty(_classNames2, "roo-input-group-".concat(classDirectory[size || 'normal']), size), _defineProperty(_classNames2, 'has-icon', prefix || suffix), _classNames2), wrapClassName);
      var fixStyle = {
        display: 'inline-flex'
      };
      var suffixfixStyle = {
        display: 'inline-flex'
      }; // 不改变input结构，hack 解决suffix与afterAppend两部分icon重合问题

      if (afterAppend) {
        _Object$assign(suffixfixStyle, {
          position: 'relative',
          transform: 'translateY(0%)',
          right: '1.5em',
          width: '0px',
          alignItems: 'center'
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: groupCls,
        style: wrapStyle
      }, prefix ? /*#__PURE__*/React.createElement("div", {
        className: "prefix-icon",
        style: fixStyle
      }, prefix) : null, preAppend ? /*#__PURE__*/React.createElement("div", {
        className: "roo-input-group-prepend"
      }, preAppend) : null, _this.renderInput(), suffix ? /*#__PURE__*/React.createElement("div", {
        className: "addon-icon",
        style: suffixfixStyle
      }, suffix) : null, afterAppend ? /*#__PURE__*/React.createElement("div", {
        className: "roo-input-group-append"
      }, afterAppend) : null);
    };

    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          status = _this$props3.status,
          preAppend = _this$props3.preAppend,
          afterAppend = _this$props3.afterAppend,
          suffix = _this$props3.suffix,
          prefix = _this$props3.prefix;

      if (status) {
        return this.renderStatus();
      } else if (preAppend || afterAppend || suffix || prefix) {
        return this.renderGroup();
      } else {
        return this.renderInput();
      }
    }
  }]);

  return Input;
}(React.Component);

Input.rooName = 'RInput';
Input.propTypes = {
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'large']),
  styleType: PropTypes.oneOf(['plaintext', 'line']),
  status: PropTypes.oneOf(['error', 'success']),
  message: PropTypes.string,
  preAppend: PropTypes.node,
  afterAppend: PropTypes.node,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  wrapClassName: PropTypes.string,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onChange: PropTypes.func
};
Input.defaultProps = {
  size: undefined,
  styleType: null,
  status: null,
  message: null,
  preAppend: null,
  afterAppend: null,
  prefix: null,
  suffix: null,
  readOnly: false,
  disabled: false,
  placeholder: '',
  type: 'text',
  className: '',
  wrapClassName: '',
  inputRef: null,
  onChange: function onChange() {}
};
export default Input;